import AlertBox from "./AlertBox";
import FieldErrorHelpLength from "./FieldErrorHelpLength";
import GadgetBox from "./GadgetBox";
import ModalStyleLess from "./ModalStyleLess";
import MyButton from "./MyButton";
import MyDropdown from "./MyDropdown";
import MyInput from "./MyInput";
import MyTable from "./MyTable";
import Pagination from "./Pagination";
import Panel from "./Panel";
import StatBoxes from "./StatBoxes";
import TableColumn from "./TableColumn";
import TableControls from "./TableControls";
import MediaPlayer from "./MediaPlayer";
import Window from "./Window";
import MyTextarea from "./MyTextarea";
import DoughnutStatBox from "./DoughnutStatBox";
import SwitchOnOff from "./SwitchOnOff";
import MyRadio from "./MyRadio";
import MyAccordion from "./MyAccordion";

let dynamicComponents = {
    'admin-dashboard': () => import('./AdminDashboard'),
    'pie-chart': () => import('./PieChart'),
    'serial-chart': () => import('./SerialChart'),
    'bar-chart': () => import('./BarChart'),
    'advanced-serial-chart': () => import('./AdvancedSerialChart')
}

let components = [
    AlertBox,
    FieldErrorHelpLength,
    GadgetBox,
    ModalStyleLess,
    MyButton,
    MyDropdown,
    MyInput,
    MyTable,
    Pagination,
    Panel,
    StatBoxes,
    TableColumn,
    TableControls,
    MediaPlayer,
    Window,
    MyTextarea,
    DoughnutStatBox,
    SwitchOnOff,
    MyRadio,
    MyAccordion
];

export default {
    install(Vue) {
        components.forEach((item) => {
            Vue.component(item.name, item);
        });
        Object.keys(dynamicComponents).forEach((name) => {
            Vue.component(name, dynamicComponents[name]);
        });
    }
}